import { Home, Login, Contact, Features } from "../views";

export const siteRouter = [
  {
    path: "/",
    name: "SiteHome",
    component: Home
  },
  {
    path: "/login",
    name: "Login",
    component: Login
  },
  {
    path: "/features",
    name: "Features",
    component: Features
  },
  {
    path: "/contact",
    name: "Contact",
    component: Contact
  }
];
